import * as queries from "@queries/utils";

export const downloadInter = () => queries.getQuery("/api/Inter");
